<script lang="ts">
    import IconAdd from "./Icons/IconAdd.svelte";

    export let text: string = 'Dodaj';
</script>

<div class="container" on:click >
    <div class="text">{text}</div>
    <IconAdd />
</div>


<style>
    .container {
        display: flex;
        align-items: center;
        column-gap: 7px;
        cursor: pointer;
        text-align: right;
    }
    .text {
        font-size: 12px;
        opacity: 0.5;
        text-align: right;
    }

</style>
